import type { AxiosResponse } from 'axios'
import type { Profile, Role } from 'types'

export enum ActionType {
  SIGN_UP = 'SIGN_UP',
  LOGOUT_USER = 'LOGOUT_USER',

  CHECK_AUTH = 'CHECK_AUTH',
  SET_AUTH = 'SET_AUTH',

  GET_PROFILE = 'GET_PROFILE',
  SET_PROFILE = 'SET_PROFILE',

  GET_ROLES = 'GET_ROLES',
  SET_ROLES = 'SET_ROLES',

  INVITE_MEMBER = 'INVITE_MEMBER',
}

export type SignUpUserPayload = {}

export type GetProfileResponse = AxiosResponse<Profile>

export type RolesResponseData = {
  total: number
  data: Role[]
}

export type GetRolesResponse = AxiosResponse<RolesResponseData>

export type InviteMemberPayload = {
  role_name: string
  email: string
  company_ids?: string[]
}

// export type InviteMemberResponse = {
//   email: string
//   company_id: string
// }
